import { get as _get } from 'lodash';

import types from '../actionTypes';

const initialState = {
    list: false,
};

export default (state = initialState, action) => {
    if (_get(action, 'meta.silent')) {
        return state;
    }
    switch (action.type) {
        case types.IMAGE_MAPS_REQUEST: {
            return {
                ...state,
                list: true,
            };
        }
        case types.IMAGE_MAPS_REQUEST_COMPLETED: {
            return {
                ...state,
                list: false,
            };
        }
        case types.DELETE_IMAGE_MAP_REQUEST: {
            return {
                ...state,
                [action.meta.id]: true,
            };
        }
        case types.DELETE_IMAGE_MAP_REQUEST_COMPLETED: {
            return {
                ...state,
                [action.meta.id]: false,
            };
        }
        default:
            return state;
    }
};
